import { configureCardAppearance } from './design-summary-view.js'
import { showBigPointLoad, bigPointLoadUnit, showLengthWithUnits } from 'ws-units';

export function showShearCheckSummary(project, results) {
  const design = project.design;
  const checks = results["shear_checks"];
  const controlling_unity = checks["controlling_unity"];
  const controlling_case = checks["controlling_case"];
  const controlling_Vu = checks["controlling_Vu"];
  const controlling_Vn = checks["controlling_Vn"];
  const controlling_equation = checks["controlling_code_equation"];
  const controlling_location = checks["controlling_loc"];
  const nice_eq_index = Number(controlling_case.split('EQ')[1]);
  const nice_case = design.loadCombination["prettyEquations"][nice_eq_index-1]["EQ"];
  const success = controlling_unity < 1.0;
  const designStatusStr = success ? '<i class="fa fa-check"></i>' : '<i class="fa fa-remove"></i>';
  configureCardAppearance('shear-design-panel', success);

  let rows = [];

  // Demand and Capacity rows
  if (project.isEngineeredLumber) {
    rows.push(makeRow("Vu (Demand)", `${showBigPointLoad(controlling_Vu)} ${bigPointLoadUnit()}`));
    let capLabel = project.shape.flitch ? "Vn + Vn<sub>steel</sub> (Capacity)" : "Vn (Capacity)";
    rows.push(makeRow(capLabel, `${showBigPointLoad(controlling_Vn)} ${bigPointLoadUnit()}`));
    if (project.shape.flitch) {
      rows.push(makeRow("Vn<sub>steel</sub> (Capacity)", "0.6 &middot; Fy &middot; A<sub>steel</sub>"));
    }
  } else if (project.isNorthAmericanSteel || design.designType === 'None') {
    const demandStr = project.isASD ? "Vr" : "Vu";
    rows.push(makeRow(`${demandStr} (Demand)`, `${showBigPointLoad(controlling_Vu)} ${bigPointLoadUnit()}`));
    let capacityStr = project.isASD ? "Vn/&Omega;" : "&Phi;Vn";
    if (project.isNoDesign) capacityStr = "Vn";
    rows.push(makeRow(`${capacityStr} (Capacity)`, `${showBigPointLoad(controlling_Vn)} ${bigPointLoadUnit()}`));
  } else {
    // Wood (shear stress)
    rows.push(makeRow("fv (Demand)", `${Number(controlling_Vu).toFixed(2)} psi`));
    rows.push(makeRow("F'v (Capacity)", `${Number(controlling_Vn).toFixed(2)} psi`));
  }

  // Controlling Equation row
  let eqValue = "";
  if (project.isEngineeredLumber) {
    eqValue = project.shape.flitch ? "Vu &le; Vn + Vn<sub>steel</sub>" : "Vu &le; Vn";
  } else if (project.isFormTechShape) {
    eqValue = controlling_equation;
  } else if (project.isNoDesign) {
    eqValue = "Vn = Fy &bull; A &bull; 0.6";
  } else {
    eqValue = controlling_equation;
  }
  rows.push(makeRow("Controlling Equation", eqValue));

  // Location and Load Combination rows
  rows.push(makeRow("Location", showLengthWithUnits(controlling_location)));
  rows.push(makeRow("Load Combination", nice_case));

  const str = `
    <div class="card-header">
      <div class="fs-6">
        ${designStatusStr} Shear
        <span class="float-end">${controlling_unity.toFixed(2)}</span>
      </div>
    </div>
    <div class='bg-white rounded-2'>
      <table class='table table-borderless'>
        ${rows.join('')}
      </table>
    </div>
  `;

  document.getElementById('shear-design-panel').innerHTML = str;
}

function makeRow(label, value) {
  return `<tr><td>${label}</td><td><span style='float:right;'>${value}</span></td></tr>`;
}
